import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import {grid} from 'styled-components-grid'
import Grid from 'styled-components-grid'
import {GridContainer} from './Styles'
import {py, px, pb, pt} from 'styled-components-spacing'
import breakpoint from 'styled-components-breakpoint';

const Nav = styled.nav`
  position: ${prop => prop.footer ? 'relative' : 'absolute'};
  width: 100%;
  padding-top: ${prop => prop.footer ? '0' : '8vw'};
  ${breakpoint('mobile')`
    height: ${prop => prop.footer ? 'auto' : '100vh'};
    background: white;
    text-align: center;
  `}
  ${breakpoint('tablet')`
    height: auto;
    background: rgba(255,255,255,.9);
    text-align: ${prop => prop.footer ? 'center' : 'left'};
  `}
`;

const NavCentered = GridContainer.withComponent('div');

const SubNav = styled.ul`
  margin: 0;
`;
const NavCol = styled.li`
  list-style: none;
  ${grid.unit({size:{mobile:1/2, tablet:1/4}})};
  ${pt({mobile:1, tablet:0})};
  ${pb({mobile:2, tablet:0})};
`;
const NavRow = styled.li`
  list-style: none;
`;
const NavLink = styled(Link)`
  text-decoration: none;
  color: black;
  ${px({mobile:2, tablet:4})}
  &:hover {
    text-decoration: underline;
  }
`;
const PrimaryLink = NavLink.extend`
  font-weight: bold;
  display: block;
  ${pb(2)}
`;
const PrimaryLabel = PrimaryLink.withComponent('a');

const SecondaryLink = NavLink.extend``;

const SecondaryA = SecondaryLink.withComponent('a');

const NavUl = Grid.withComponent('ul');

export const findUrl = (slug, pages) => {
  const foundUrl = pages.edges.find(pageData => pageData.node.path.match(slug));
  return foundUrl.node.path;
}

class Navigation extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    return (
      <Nav footer={this.props.footer}>
        <NavCentered>
          <NavUl halign="center">
            {this.props.links.map((link, id) => {
              const url = findUrl(link.primary.link.slug, this.props.pagesUrl);
              return (
                <NavCol key={`navCol-${id}`}>
                  {link.primary.link.slug ? (
                    <PrimaryLink to={url}>{link.primary.name}</PrimaryLink>
                  ) : (
                    <PrimaryLabel>{link.primary.link}</PrimaryLabel>
                  )}
                  {link.items[0].name && 
                    <SubNav>
                      {link.items.map((subLink, subId) => {
                        const subMenuUrl = findUrl(subLink.link.slug, this.props.pagesUrl);
                        return (
                          !subLink.link.url ? (
                            <NavRow key={`navcol-${id}-col-${subId}`}>
                              <SecondaryLink to={subMenuUrl}>– {subLink.name}</SecondaryLink>
                            </NavRow>
                          ) : (
                            <NavRow key={`navcol-${id}-col-${subId}`}><SecondaryA href={subLink.link.url} target="_blank">– {subLink.name}</SecondaryA></NavRow>
                          )
                        )
                      })}
                    </SubNav>
                  }
                </NavCol>
              )
            })}
            {this.props.injectContact && 
              <NavCol>
                <PrimaryLink to="/contact">Contact</PrimaryLink>
                <SubNav>
                  <NavRow><SecondaryA href="/tarifs">– Tarifs</SecondaryA></NavRow>
                  <NavRow><SecondaryA href="tel:0041774105184">– 077 410 51 84</SecondaryA></NavRow>
                  <NavRow><SecondaryA href="http://chatriwalla.airfly.ch/">– Blog</SecondaryA></NavRow>
                </SubNav>
              </NavCol>
            }
          </NavUl>
        </NavCentered>
      </Nav>
    )
  }
}

export default Navigation;


export const NavigationFragment = graphql`
  fragment NavigationLinks on PrismicDocument {
    data {
       body {
        primary {
          name
          link {
            slug
            data {
              title { 
                text 
              }
            }
          }
        }
        items {
          name
          link {
            slug
            data {
              title { 
                text 
              }
            }
          }
        }
      }
    }
  }
  fragment MenuMeteo on PrismicDocument {
    data {
      title_of_this_menu {
        text
      }
      tip_links {
        name
        link {
          slug
          data {
            title { 
              text 
            }
          }
        }
      }
      useful_links {
        name
        link {
          url
        }
      }
      webcams {
        name
        link {
          url
        }
      }
    }
  }
  fragment PagesUrl on SitePageConnection {
    edges {
      node {
        path
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/Navigation.js